/** Night stop of the play-panel wash. Daylight overrides it with `--riftbound-shell-top`. */
export const NIGHT_SHELL_TOP = '#120B22';

/**
 * The status-bar inset sits outside the panel, so it has to be this color.
 * The panel gradient starts here; the page background is lighter in daylight.
 */
export const PLAY_SHELL_TOP_BG = `var(--riftbound-shell-top, ${NIGHT_SHELL_TOP})`;

/** Play-route washes. They follow the palette tokens, with the classic night shell as the fallback. */
export const PLAY_SHELL_BG =
  'radial-gradient(circle at 50% 48%, rgba(var(--riftbound-shell-glow, 124, 92, 255), 0.12), transparent 34%), var(--chakra-colors-riftbound-bg, #0F0B1A)';

const panelWash = (glowAlpha: number) =>
  `radial-gradient(circle at 50% 50%, rgba(var(--riftbound-shell-glow, 124, 92, 255), ${glowAlpha}), transparent 36%), linear-gradient(180deg, ${PLAY_SHELL_TOP_BG} 0%, var(--chakra-colors-riftbound-bg, #0F0B1A) 100%)`;

export const PLAY_PANEL_BG = panelWash(0.26);

export const PLAY_PANEL_BG_SOFT =
  `radial-gradient(circle at 50% 50%, rgba(var(--riftbound-shell-glow, 124, 92, 255), 0.22), transparent 34%), linear-gradient(180deg, ${PLAY_SHELL_TOP_BG} 0%, var(--chakra-colors-riftbound-bg, #0F0B1A) 100%)`;
